import { ConfirmModalComponent, SynDialogConfig } from '$synapse/core';
import { Group } from '$synapse/models';
import { GroupService } from '$synapse/services';
import { Component, Input, inject, input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { SHARED_IMPORTS } from '../../../core/shared-imports';
import { GroupUpdateModalComponent } from '../group-update-modal/group-update-modal.component';

@Component({
  selector: 'syn-group-description-card',
  templateUrl: './group-description-card.component.html',
  styleUrls: ['./group-description-card.component.scss'],
  imports: [SHARED_IMPORTS],
})
export class GroupMetadataWidgetComponent {
  private readonly _groupService = inject(GroupService);
  private readonly _route = inject(ActivatedRoute);
  private readonly _router = inject(Router);
  private readonly _modalDialog = inject(MatDialog);

  @Input() group: Group;
  readonly hasAssessment = input<boolean>(undefined);

  modifyGroup() {
    const modalConf = new SynDialogConfig(
      'group-update-modal-component',
      this.group
    );
    const dialogRef = this._modalDialog.open(
      GroupUpdateModalComponent,
      modalConf
    );
    dialogRef.afterClosed().subscribe((group: Group) => {
      if (group) {
        this.group = group;
      }
    });
  }

  deleteGroup() {
    const dialogRef = this._modalDialog.open(
      ConfirmModalComponent,
      new SynDialogConfig('delete-candidate-confirmation')
    );
    const instance = dialogRef.componentInstance;
    instance.title = 'Suppression de groupe';
    instance.message = 'Êtes-vous sûr de vouloir supprimer ce groupe ?';
    instance.action = 'Supprimer';
    instance.warn =
      'Attention ! Toutes les évaluations du groupe seront supprimées';
    dialogRef.componentInstance.confirmationEvent.subscribe(() => {
      this._groupService
        .deleteGroup(this._route.snapshot.params['id'])
        .subscribe((isSuccess) => {
          if (isSuccess) {
            this._router.navigate(['/groups']);
          }
        });
    });
  }
}
